var BillingAddress = (function ($, api, GlobalSettings) {

	var BillingAddress = function (options) {
		this.container = options.container;
		this.model = options.model;
		this.$el = $.tmpl('billingAddress');
	};

	BillingAddress.prototype = {
		_hiddenClass: 'hidden-block',
		_init: function () {
			this.$input = this.$el.find('@newBilling');
			this.$label = this.$el.find('@currentBilling');

			this.$label.on('click', $.proxy(function() {
				this._displayInput().focus();
			}, this));
			this.$input.on('blur', $.proxy(this._saveByBlur, this));

			this.model.on('isValid', $.proxy(this._isValid, this));

			this.container.append(this.$el);

			this._toggle();
		},
		_isValid: function(isValid) {
			!isValid && this.$input.addClass('incorrect-billing-address');
			isValid && this.$input.removeClass('incorrect-billing-address');
		},
		_toggle: function () {
			this._displayInput();
			//this.model._isValid() ? this._displayLabel() : this._displayInput();
		},
		_displayInput: function() {
			this.$label.addClass(this._hiddenClass);
			return this.$input.removeClass(this._hiddenClass)
				.val(this.model.get('Label') || '');
		},
		_displayLabel: function() {
			if (this.model._isValid()) {
				this.$input.addClass(this._hiddenClass);
				this.$label.removeClass(this._hiddenClass).html((this.model.get('Label') || '').replace(/\n/g, '</br>'));
			}
		},
		_saveByBlur: function() {
			var value = this.$input.val();
			this._save({ Label: value });
		},
		_save: function (address) {
			this._isValid(!!address && address.Label);
			this.model.update(address).done($.proxy(this._toggle, this));
		},
		update: function(address) {
			this._isValid(this.hasAddress());
			this._toggle();
		},
		hasAddress: function() {
			return !!this.model.get('Label');
		}
	};

	return BillingAddress;

})(jQuery, api, GlobalSettings);